import { useLocation, Navigate, Outlet } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import NoPermission from "../components/information_cards/NoPermission";

const RequireAuth = ({ permissions }) => {
  const { auth } = useAuth();
  const location = useLocation();

  if (auth?.staff_id) {
    if (!permissions || permissions.length === 0) {
      return <Outlet />;
    }

    const hasPermission = permissions.some((permission) =>
      auth?.permissions.includes(permission)
    );

    if (hasPermission) {
      return <Outlet />;
    } else {
      return <NoPermission />;
    }
  } else {
    return <Navigate to="/" state={{ from: location }} replace />;
  }
};

export default RequireAuth;
